import React from "react";
import { Link } from "react-router-dom";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { Layout as Layouts, Switch, Modal, Input, message, Spin } from "antd";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import Footerlayout from "./footer/index";
import { ArrowLeftOutlined, CloseCircleFilled } from "@ant-design/icons";
import Walleticon from "../../assets/images/Wallet/wallet-icon.png";
import { getUserData } from "../../utils/Helpers";
import { AppConfig } from "../../utils/Config/AppConfig";
import { ApiRoutes } from "../../utils/Config/ApiRoutes";
import { ApiHelper } from "../../utils/Helpers";
import { messages } from "../../utils/Common/Messages";
import ElavonLogo from "../../assets/images/elavon_primary_logo.png";

const Layout = (props) => {
  const lan = getUserData().language ?? "EN";
  const defaultCurrency = getUserData().currencySign;

  const { setIsDarkMode, isDarkMode } = props;
  const { itu, organizationTypeId, parentOrganizationId , organizationId } = getUserData();
  const { Header } = Layouts;
  const history = useHistory();
  //const { Header, Sider } = Layouts;
  //  const [isDarkMode, setIsDarkMode] = React.useState();
  //const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [walletAmount, setWelletAmount] = React.useState();
  const [isElavonActive, setIsElavonActive] = React.useState(false);
  const [isLoadWalletModalVisible, setIsLoadWalletModalVisible] =
    React.useState(false);
  const [loadAmount, setLoadAmount] = React.useState(0);
  const [cardNumber, setCardNumber] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState("");
  const [cvv, setCvv] = React.useState("");
  const [cardHolderName, setCardHolderName] = React.useState("");
  const [isWalletLoading, setIsWalletLoading] = React.useState(false);
  const [processingFee, setProcessingFee] = React.useState(0);
  const [totalChargedAmount, setTotalChargedAmount] = React.useState(0);
  const [isFeeLoading, setIsFeeLoading] = React.useState(false);
  const { switcher, themes } = useThemeSwitcher();
  const isWalletPage = history?.location?.pathname === "/wallet";
  const toggleTheme = (isChecked) => {
    setIsDarkMode(isChecked);
    switcher({ theme: isChecked ? themes.dark : themes.light });
  };
  const url =
    organizationTypeId === 1 || organizationTypeId === "1"
      ? AppConfig.RETAILERURL
      : AppConfig.SUPERMERCHANTURL;

  const getWalletBalance = async (userData) => {
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.GET_WALLET_BAL.service,
      ApiRoutes.GET_WALLET_BAL.url,
      ApiRoutes.GET_WALLET_BAL.method,
      ApiRoutes.GET_WALLET_BAL.authenticate,
      undefined,
      {
        parentOrganizationId: userData?.parentOrganizationId,
        organizationId: userData?.organizationId,
        organizationTypeId: getUserData().organizationTypeId,
      }
    );
    if (response.code === 200) {
      setWelletAmount(response.data?.response?.data?.walletAmount || 0.0);
      const elavonActiveValue =
        response.data?.response?.data?.isElavonActive ??
        response.data?.response?.isElavonActive ??
        response.data?.data?.isElavonActive ??
        response.data?.isElavonActive;
      setIsElavonActive(
        elavonActiveValue === true ||
          elavonActiveValue === "true" ||
          elavonActiveValue === 1 ||
          elavonActiveValue === "1"
      );
    } else {
      setWelletAmount(0.0);
      setIsElavonActive(false);
    }
  };

  React.useEffect(() => {
    const userData = getUserData();
    if (userData === undefined || userData === "") {
      window.location.href = AppConfig.ROOTURL;
      // } else if (userData.organizationTypeId === 1) {
      //   //setUrl(AppConfig.RETAILERURL);
      // } else if (
      //   userData.organizationTypeId === 2 &&
      //   userData.metaKey === "MERCHANT_STORE_TYPE"
      // ) {
      //   // setUrl(AppConfig.SUPERMERCHANTURL);
      // } else if (userData.organizationTypeId === 2) {
      //   //setUrl(AppConfig.SUPERMERCHANTURL);
      // }
    } else {
      getWalletBalance(userData);
    }
  }, []);

  // Debounce timer ref for fee calculation
  const feeCalculationTimerRef = React.useRef(null);

  const calculateProcessingFee = async (amount) => {
    if (!amount || Number(amount) <= 0) {
      setProcessingFee(0);
      setTotalChargedAmount(0);
      return;
    }

    setIsFeeLoading(true);
    try {
      const response = await new ApiHelper().FetchFromServer(
        ApiRoutes.WALLET_LOAD_CALCULATE_FEE.service,
        ApiRoutes.WALLET_LOAD_CALCULATE_FEE.url,
        ApiRoutes.WALLET_LOAD_CALCULATE_FEE.method,
        ApiRoutes.WALLET_LOAD_CALCULATE_FEE.authenticate,
        undefined,
        {
          amount: Number(amount),
        }
      );

      if (response.code === 200 && response.data) {
        const responseData = response.data.response || response.data.data || response.data;
        const feeAmount = responseData.feeAmount || 0;
        const totalAmount = responseData.totalAmount || 0;
        setProcessingFee(Number(feeAmount));
        setTotalChargedAmount(Number(totalAmount));
      } else {
        setProcessingFee(0);
        setTotalChargedAmount(0);
      }
    } catch (error) {
      console.error("Error calculating processing fee:", error);
      setProcessingFee(0);
      setTotalChargedAmount(0);
    } finally {
      setIsFeeLoading(false);
    }
  };

  const closeLoadWalletModal = () => {
    setIsLoadWalletModalVisible(false);
    // Clear fee calculation timer on modal close
    if (feeCalculationTimerRef.current) {
      clearTimeout(feeCalculationTimerRef.current);
    }
  };

  const openLoadWalletModal = () => {
    setIsLoadWalletModalVisible(true);
  };

  const resetLoadWalletForm = () => {
    setLoadAmount(0);
    setCardNumber("");
    setExpiryDate("");
    setCvv("");
    setCardHolderName("");
    setProcessingFee(0);
    setTotalChargedAmount(0);
    if (feeCalculationTimerRef.current) {
      clearTimeout(feeCalculationTimerRef.current);
    }
  };

  const handleLoadAmountChange = (event) => {
    const value = event.target.value;
    if (value === "") {
      setLoadAmount("");
      setProcessingFee(0);
      setTotalChargedAmount(0);
      // Clear any pending fee calculation
      if (feeCalculationTimerRef.current) {
        clearTimeout(feeCalculationTimerRef.current);
      }
      return;
    }

    // Allow only digits with optional decimal part (up to 2 places).
    if (!/^\d+(\.\d{0,2})?$/.test(value)) {
      return;
    }

    setLoadAmount(value);

    // Debounce the fee calculation (wait 500ms after user stops typing)
    if (feeCalculationTimerRef.current) {
      clearTimeout(feeCalculationTimerRef.current);
    }
    feeCalculationTimerRef.current = setTimeout(() => {
      calculateProcessingFee(value);
    }, 500);
  };

  const handleCardNumberChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, 16);
    const formattedValue = digitsOnly.replace(/(.{4})/g, "$1 ").trim();
    setCardNumber(formattedValue);
  };

  const handleExpiryDateChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, 4);
    if (digitsOnly.length <= 2) {
      setExpiryDate(digitsOnly);
      return;
    }
    setExpiryDate(`${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`);
  };

  const handleCvvChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, 4);
    setCvv(digitsOnly);
  };

  const validateCardholderName = (name) => {
    // Trim leading and trailing spaces
    const trimmedName = name.trim();

    // Check if empty
    if (!trimmedName) {
      return { valid: false, error: "Cardholder name is required" };
    }

    // Check minimum length (2 characters)
    if (trimmedName.length < 2) {
      return { valid: false, error: "Cardholder name must be at least 2 characters" };
    }

    // Check maximum length (100 characters)
    if (trimmedName.length > 100) {
      return { valid: false, error: "Cardholder name must not exceed 100 characters" };
    }

    // Check if numeric-only (reject)
    if (/^\d+$/.test(trimmedName)) {
      return { valid: false, error: "Cardholder name cannot contain only numbers" };
    }

    // Check for invalid special characters
    // Allowed: Letters, International characters, Spaces, Hyphens (-), Apostrophes ('), Periods (.)
    // Reject: @, #, $, %, ^, &, *, <, >, { }, [ ], |, ~
    const invalidCharsRegex = /[@#$%^&*<>{}[\]|~]/;
    if (invalidCharsRegex.test(trimmedName)) {
      return { valid: false, error: "Cardholder name contains invalid characters" };
    }

    // Valid pattern: letters (including international), spaces, hyphens, apostrophes, periods
    const validNameRegex = /^[a-zA-ZÀ-ÿ\s'\-.]+$/;
    if (!validNameRegex.test(trimmedName)) {
      return { valid: false, error: "Cardholder name contains invalid characters" };
    }

    return { valid: true, trimmedName };
  };

  const handleWalletLoad = async () => {
    if (!Number(loadAmount) || Number(loadAmount) <= 0) {
      message.error("Enter a valid load amount");
      return;
    }
    if (!cardNumber || !expiryDate || !cvv || !cardHolderName) {
      message.error("Please fill all card details");
      return;
    }

    const cardNumberForApi = cardNumber.replace(/\s/g, "");
    if (cardNumberForApi.length !== 16) {
      message.error("Card number must be 16 digits");
      return;
    }
    if (!/^(0[1-9]|1[0-2])\/[0-9]{2}$/.test(expiryDate)) {
      message.error("Enter expiry date in MM/YY format");
      return;
    }
    if (!/^\d{3,4}$/.test(cvv)) {
      message.error("CVV must be 3 or 4 digits");
      return;
    }

    // Validate cardholder name
    const nameValidation = validateCardholderName(cardHolderName);
    if (!nameValidation.valid) {
      message.error(nameValidation.error);
      return;
    }

    setIsWalletLoading(true);
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.WALLET_LOAD.service,
      ApiRoutes.WALLET_LOAD.url,
      ApiRoutes.WALLET_LOAD.method,
      ApiRoutes.WALLET_LOAD.authenticate,
      undefined,
      {
        organizationTypeId,
        parentOrganizationId,
        organizationId,
        amount: Number(loadAmount),
        feeAmount: Number(processingFee),
        totalCharged: Number(totalChargedAmount),
        cardNumber: cardNumberForApi,
        expiryDate,
        cvv,
        cardHolderName: nameValidation.trimmedName,
      }
    );

    const apiData = response?.data || {};
    const isBusinessSuccess =
      apiData.success === 1 ||
      apiData.success === "1" ||
      apiData.success === true;
    const successMessage =
      apiData.response?.message || apiData.message || "Wallet loaded successfully";
    const errorMessage =
      apiData.response?.gatewayResponse?.errorMessage ||
      apiData.response?.message ||
      apiData.error ||
      response.message ||
      "Unable to load wallet";

    if (response.code === 200 && isBusinessSuccess) {
      message.success(successMessage);
      const userData = getUserData();
      getWalletBalance(userData);
      window.dispatchEvent(new Event("wallet:history:refresh"));
      closeLoadWalletModal();
      resetLoadWalletForm();
    } else {
      message.error(errorMessage);
    }
    setIsWalletLoading(false);
  };
  return (
    <>
      <div className="ekiakrtApp" id="ekikartLayout">
        <Layouts style={{ minHeight: "100vh" }}>
          {/*<MediaQuery minDeviceWidth={992}>
            <Sider
              trigger={null}
              collapsible
              collapsed={isCollapsed}
              width={230}
              className="ekikartSidebar"
            >
              <Sidebarlayout />
            </Sider>
          </MediaQuery>
          <MediaQuery maxDeviceWidth={991}>
            <Sider
              trigger={null}
              collapsible
              collapsed={!isCollapsed}
              width={230}
              className="ekikartSidebar"
            >
              <Sidebarlayout />
            </Sider>
          </MediaQuery>*/}
          <Layouts className="site-layout">
            <Header className="bg-white p-0 horizontalMenuOnlyHeader">
              {/*{React.createElement(
                isCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: () => setIsCollapsed(!isCollapsed),
                }
              )}*/}
              {/* <button
                onClick={() => history.goBack()}
                type="secondary"
                className="ant-btn ant-btn-secondary float-left"
              >
                <ArrowLeftOutlined /> Back
              </button> */}
              <span className="mr-auto">
                {history?.location?.pathname === "/" ? (
                  <a href={url}>
                    <Button
                      type="primary"
                      onClick={() => history.goBack()}
                      icon={<ArrowLeftOutlined />}
                      className="m-10"
                    />
                  </a>
                ) : (
                  <Button
                    type="primary"
                    onClick={() => history.goBack()}
                    icon={<ArrowLeftOutlined />}
                    className="m-10"
                  />
                )}
              </span>
              {walletAmount !== undefined &&
              (itu === "true" || itu === true) ? (
                <div className="walletHeaderActions">
                  {isWalletPage && isElavonActive ? (
                    <span className="walletLoadBtnWrap">
                      <Button
                        type="primary"
                        className="walletLoadBtn"
                        onClick={openLoadWalletModal}
                      >
                        Load Wallet
                      </Button>
                    </span>
                  ) : (
                    ""
                  )}
                  <Link to="/wallet" className="walletAmountBox">
                    <div className="walletIcon mr-1">
                      <img src={Walleticon} alt="Wallet Icon" width="38" />
                    </div>
                    <div className="walletAmount">
                      <h5>{messages.balance[lan]}</h5>
                      <h4 className="amountText">
                        {defaultCurrency}
                        {Number(
                          parseFloat(walletAmount).toFixed(2)
                        ).toLocaleString(
                          undefined, // leave undefined to use the visitor's browser
                          // locale or a string like 'en-US' to override it.
                          { minimumFractionDigits: 2 }
                        )}
                      </h4>
                    </div>
                  </Link>
                </div>
              ) : (
                ""
              )}
              <Switch
                checked={isDarkMode}
                onChange={toggleTheme}
                className="ant-dropdown-link float-right m-10"
              />
              {/*<Headerlayout {...props} />*/}
            </Header>
            <>{props.children}</>
            <Modal
              visible={isLoadWalletModalVisible}
              footer={null}
              onCancel={closeLoadWalletModal}
              width={500}
              centered
              className="loadWalletModal"
              destroyOnClose
              closeIcon={<CloseCircleFilled className="loadWalletModalClose" />}
              title="Load wallet via card payment"
            >
              <div className="loadWalletForm">
                <h4 className="loadWalletLabel">Enter Load Amount</h4>
                <Input
                  className="loadWalletAmountInput"
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9]*"
                  value={loadAmount}
                  onChange={handleLoadAmountChange}
                  prefix={defaultCurrency}
                />

                <h4 className="loadWalletSectionTitle">Enter Card Details</h4>

                <label className="loadWalletFieldLabel">Card Number</label>
                <Input
                  value={cardNumber}
                  onChange={handleCardNumberChange}
                  className="loadWalletFieldInput"
                  inputMode="numeric"
                  maxLength={19}
                  placeholder="1234 5678 9012 3456"
                />

                <div className="loadWalletRow">
                  <div className="loadWalletCol">
                    <label className="loadWalletFieldLabel">Expiry Date (MM/YY)</label>
                    <Input
                      value={expiryDate}
                      onChange={handleExpiryDateChange}
                      className="loadWalletFieldInput"
                      inputMode="numeric"
                      maxLength={5}
                      placeholder="MM/YY"
                    />
                  </div>
                  <div className="loadWalletCol">
                    <label className="loadWalletFieldLabel">CVV</label>
                    <Input
                      value={cvv}
                      onChange={handleCvvChange}
                      className="loadWalletFieldInput"
                      inputMode="numeric"
                      maxLength={4}
                      placeholder="123"
                    />
                  </div>
                </div>

                <label className="loadWalletFieldLabel">Cardholder Name</label>
                <Input
                  value={cardHolderName}
                  onChange={(event) => setCardHolderName(event.target.value)}
                  className="loadWalletFieldInput"
                />

                <div className="loadWalletSummary">
                  <div className="loadWalletSummaryRow">
                    <span>Card Handling Fee</span>
                    <span>
                      {isFeeLoading ? (
                        <Spin size="small" />
                      ) : (
                        `${defaultCurrency}${Number(processingFee).toFixed(2)}`
                      )}
                    </span>
                  </div>
                  <div className="loadWalletSummaryRow">
                    <span>Total Charged to Card</span>
                    <span>
                      {isFeeLoading ? (
                        <Spin size="small" />
                      ) : (
                        `${defaultCurrency}${Number(totalChargedAmount).toFixed(2)}`
                      )}
                    </span>
                  </div>
                </div>

                <div className="loadWalletFooter">
                  <span className="loadWalletProvider">
                    Processed securely via Elavon{" "}
                    <img
                      src={ElavonLogo}
                      alt="Elavon"
                      className="loadWalletProviderLogo"
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                      }}
                    />
                  </span>
                  <Button
                    type="primary"
                    className="loadWalletSubmitBtn"
                    onClick={handleWalletLoad}
                    loading={isWalletLoading}
                  >
                    Load Wallet
                  </Button>
                </div>
              </div>
            </Modal>
            <Footerlayout />
          </Layouts>
        </Layouts>
      </div>
    </>
  );
};

export default Layout;
